import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAcorn = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 640 640",
		...props,
		children: /* @__PURE__ */ _jsx("path", { d: "M324.8 73.6C332.8 63 347.8 60.9 358.4 68.8C369 76.8 371.1 91.8 363.2 102.4L358.4 108.8C354 114.7 350.6 121.2 348.2 128L448 128L452.9 128.1C503.7 130.7 544 172.6 544 224L544 256L543.8 259.3C542.3 274.3 530.3 286.3 515.2 287.9L511.9 288.1L495.9 288.1L495.5 303.2C491.7 381.3 456.9 493.2 330 540.5L325 541.9C321.6 542.5 318.1 542.5 314.7 541.9L309.7 540.5C183 493.1 148.2 381.3 144.4 303.1L144 288L128 288L124.7 287.8C109.6 286.3 97.7 274.3 96.1 259.2L96 256L96 224C96 172.6 136.3 130.7 187.1 128.1L192 128L298.5 128C302 110.7 309.3 94.3 320 80L324.8 73.6zM192.3 300.9C195.5 367 223.7 453.5 320 492.8C422.7 450.9 448 355.3 448 288L192 288L192.3 300.9zM192 176C165.5 176 144 197.5 144 224L144 240L496 240L496 224C496 197.5 474.5 176 448 176L192 176z" })
	});
};
export default SvgAcorn;
